export const PaymentCardIdForRemoveTransaction = 0;
